(() => {
  const selector = '[data-crux-dark-live-video]';

  const initialise = (video) => {
    if (video.dataset.cruxPlaybackReady === 'true') return;
    video.dataset.cruxPlaybackReady = 'true';

    const restingFrame = Number(video.dataset.cruxRestingFrame || 0);
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let autoPlaySucceeded = false;
    let isVisible = false;
    let observer;

    const seekToRestingFrame = () => {
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      video.pause();
      video.currentTime = Math.min(restingFrame, Math.max(0, duration - 0.05));
    };

    const attemptPlay = async ({ restart = false, automatic = false } = {}) => {
      if (automatic && (autoPlaySucceeded || !isVisible || reducedMotion.matches)) return false;
      if (!restart && !video.paused) return true;
      if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
        video.load();
        return false;
      }

      if (restart || video.ended) video.currentTime = 0;
      try {
        await video.play();
        if (automatic) {
          autoPlaySucceeded = true;
          observer?.disconnect();
        }
        return true;
      } catch (_) {
        return false;
      }
    };

    video.addEventListener('ended', seekToRestingFrame);
    video.addEventListener('click', () => attemptPlay({ restart: true }));
    video.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      attemptPlay({ restart: true });
    });

    if (finePointer.matches) {
      video.addEventListener('mouseenter', () => attemptPlay());
    } else if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        const entry = entries.find((item) => item.target === video);
        isVisible = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.4);
        if (isVisible) attemptPlay({ automatic: true });
      }, { threshold: [0, 0.4, 0.75] });
      observer.observe(video);
      video.addEventListener('canplay', () => {
        if (isVisible && !autoPlaySucceeded) attemptPlay({ automatic: true });
      });
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !video.paused) video.pause();
    });
  };

  const initialiseAll = (root = document) => root.querySelectorAll(selector).forEach(initialise);
  initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
